import { subscribeChannel, publishChannel } from './channelUtils';

// =========================
// ACTIVE
// =========================

export function sendPezinhoActive(active) {

    publishChannel('pezinho-active', active);

}

// =========================
// PERIOD
// =========================

export function sendPezinhoPeriod({
    startAt,
    endAt
}) {

    publishChannel(
        'pezinho-period',
        {
            startAt,
            endAt
        }
    );

}

// =========================
// VEHICLES
// =========================

export function sendPezinhoVehicles(vehicles) {

    publishChannel('pezinho-vehicles', vehicles);

}

// =========================
// SELECTED VEHICLES
// =========================

export function sendPezinhoSelectedVehicles(
    selectedVehicles
) {

    publishChannel('pezinho-selected-vehicles', selectedVehicles);

}

// =========================
// SELECTED POSITIONS
// =========================

export function sendPezinhoSelectedPosition(
    position
) {

    publishChannel('pezinho-selected-position', position);

}

// =========================
// CLEAR RESULTS
// =========================

export function sendClearPezinhoResults() {

    publishChannel('pezinho-clear-results');

}

// =========================
// CLEAR
// =========================

export function sendClearPezinho() {

    publishChannel('pezinho-clear');

}

export function sendResetPezinhoSearch() {

    publishChannel('pezinho-reset-search');

}

// =========================
// LISTENER
// =========================

export function listenPezinho(callback) {

    return subscribeChannel((event) => {

        const {
            tipo,
            payload
        } = event.data;

        if (
            tipo !== 'pezinho-active' &&
            tipo !== 'pezinho-period' &&
            tipo !== 'pezinho-vehicles' &&
            tipo !== 'pezinho-selected-vehicles' &&
            tipo !== 'pezinho-selected-position' &&
            tipo !== 'pezinho-clear-results' &&
            tipo !== 'pezinho-clear' &&
            tipo !== 'pezinho-reset-search'
        ) {
            return;
        }

        callback({
            tipo,
            payload
        });

    });

}